<template>
    <div>
    <div class="c"></div>
    <div id="bd">
        <div  class="bannerImg" >
            <!-- id="ban-in" -->
            <img src="../assets/Images/zhyy-banner.jpg">
        </div>
        <!-- end #banner -->
        <div class="yy-menubox">
            <div class="wp">
                <div class="yy-menuList" @click="changemenu(0)">
                    <div class="triangle"></div>
                    <img src="../assets/Images/zhyy-menu_12.png">
                    <div class="yy-menu">核心业务</div>
                    <p>符合住建部“ 双贯标 ”要求，以及归集、提取、贷款业务规范，提供满足一站办理、交易安全、账务准确的核心业务解决方案。</p>
                </div>
                <div class="yy-menuList" @click="changemenu(1)">
                    <div class="triangle"></div>
                    <img src="../assets/Images/zhyy-menu_14.png">
                    <div class="yy-menu">综合服务</div>
                    <p>遵从住建部“ 综合服务平台建设导则 ”的要求，提供业务全渠道覆盖、全渠道统一管理的综合服务平台解决方案。</p>
                </div>
                <div class="yy-menuList" @click="changemenu(2)">
                    <div class="triangle"></div>
                    <img src="../assets/Images/zhyy-menu_16.png">
                    <div class="yy-menu">综合管理</div>
                    <p>结合公积金行业管理特色，以满足中心内部管理信息化为基础，提升管理效率为目标，打造全面的公积金内部管理解决方案。</p>
                </div>
            </div>
        </div>
        
        <div class="" id="whous">
            <!--核心业务-->
            <div v-if="indexflag == 0">
                <img src="../assets/Images/hxyw_02.png">  
                <div class="tit-i">
                    <h3>核心业务</h3>
                    <h5><span>BUSINESS</span></h5>
                </div>
                <div class="zh-linebox bg-gray">
                    <div class="imgleft">
                        <img src="../assets/Images/hxyw_04.png">
                    </div>
                    <div class="zh-content ">
                        <h3>标准规范:</h3>
                        <!-- <div class="content-subtitle">符合国家要求 业务标准、数据标准、结算标准<br><br>全账户覆盖,全业务覆盖</div> -->
                        <p style="width:70%">
                            严格遵守住建部“双贯标”标准，归集、提取、贷款业务规范，符合基础数据标准、结算账户标准、结算业务全覆盖要求，提供规范、高效的公积金中心业务办理服务。
                        </p>
                    </div>
                </div>
                <div class="zh-linebox ">
                    <div class="zh-content content-left" style="padding-top:140px;">
                        <h3>客户为中心,一套客户信息</h3>
                        <!-- <div class="content-subtitle">贷款一站式办理</div> -->
                        <p style="width:80%">
                            建立以客户为中心的服务管理模式，为单位经办人、缴存职工、异地借款人、配偶、直系亲属建立一套客户信息，保证身份信息安全、一致，以便提供差异化服务。
                        </p>
                    </div>
                    <div class="imgright" style="float:right;padding-top:80px">
                        <img  src="../assets/Images/hxyw_08.png">
                    </div>
                </div>
                <div class="zh-linebox bg-gray " style="position:relative;height:500px;overflow: visible">
                    <div class="wp" style="text-align:center;padding-top:20px">
                        <h3 style="margin:10px 0 5px 0">缴存多模式自动匹配</h3>
                        <img src="../assets/Images/hxyw_11.png" style="width:100%;">
                    </div>
                </div>
                <div class="zh-linebox bg-gray" style="margin-top:240px">
                    <div class="imgleft">
                        <img src="../assets/Images/hxyw_14.png">
                    </div>
                    <div class="zh-content ">
                        <h3>贷款一站式办理</h3>
                        <p style="width:70%">
                            实现征信查询、贷款申请、抵押登记、担保登记、贷款审批一站式办理，借助抵押代办，担保代办实现贷款职工最多跑一次的贷款办理模式。
                        </p>
                    </div>
                </div>
                <div class="zh-linebox ">
                    <div class="zh-content content-left" style="padding-top:80px;">
                        <h3>财务多维辅助核算 </h3>
                        <p>借助财务多维辅助核算模式，实现公积金中心财务科目一级化，使财务分析多角度、多维度，财务结构清晰，易于管理。
                        </p>
                    </div>
                    <div class="imgright">
                        <img  src="../assets/Images/hxyw_18.png">
                    </div>
                </div>
                <div class="zh-linebox bg-gray">
                    <div class="imgleft">
                        <img src="../assets/Images/hxyw_21.png">
                    </div>
                    <div class="zh-content ">
                        <h3>提取一档多用</h3>
                        <p style="width:70%">
                            办理提取时，同一提取档案自动识别提档，减少档案采集的繁琐过程，实现缴存职工一证办理提取。
                        </p>
                    </div>
                </div>
                <div class="zh-linebox" style="position:relative;padding-top:60px;">
                        <h3 style="position: absolute;left:50%;margin-left:-60px">日终对账</h3>
                        <img src="../assets/Images/hxyw_24.png" style="width:100%;">
                </div>
                <div class="zh-linebox bg-gray">
                    <div class="imgleft">
                        <img src="../assets/Images/hxyw_26.png">
                    </div>
                    <div class="zh-content ">
                        <h3>人民银行征信直连</h3>
                        <!-- <div class="content-subtitle">符合国家要求 业务标准、数据标准、结算标准<br><br>全账户覆盖,全业务覆盖</div> -->
                        <p style="width:70%">
                            东北首家实现公积金中心与人民银行直连对接，通过人民银行前置端系统直接上报征信信息、查询缴存职工征信报告，实现贷款安全办理。
                        </p>
                    </div>
                </div>
                <!--产品-->
                <div class="wp">
                    <div class="tit-i">
                        <h3>产品</h3>
                        <h5><span>PRODUCTS</span></h5>
                    </div>
                    <ul class="product">
                        <li>千极客户信息管理系统</li>
                        <li>千极归集提取管理系统</li>
                        <li>千极个人贷款管理系统</li>
                        <li>千极财务核算系统</li>
                        <li>千极资金管理系统</li>
                        <li>千极清算对账系统</li>
                        <li>千极资金实时结算系统</li>
                        <li>千极系统管理系统</li>
                        <li>千极电子附件管理系统</li>
                        <li>千极查询统计系统</li>
                        <li>千极数据仓库系统</li>
                        <li>千极报表系统</li>
                        <li>千极工作流系统</li>
                        <li>千极运行监控系统</li>

                    </ul>
                </div>
            </div>

            <!--综合服务-->
            <div v-if="indexflag == 1 ">
                <img src="../assets/Images/zzyy-1.jpg">  
                <div class="tit-i">
                    <h3>综合服务</h3>
                    <h5><span>SERVICE</span></h5>
                </div>
                <div class="zh-linebox bg-gray">
                    <div class="imgleft">
                        <img src="../assets/Images/zhyy-img_01.png">
                    </div>
                    <div class="zh-content ">
                        <h3>服务民生，业务"零跑路"</h3>
                        <!-- <div class="content-subtitle">贷款一站式办理</div> -->
                        <p style="width:70%">基于互联网、移动互联网的快速发展，将业务从传统的柜台模式扩展为“互联网+”的办理模式，使公积金中心的客户能够足不出户的办理相关业务。
                        </p>
                    </div>
                </div>
                <div class="zh-linebox ">
                    <div class="zh-content content-left" style="padding-top:80px;">
                        <h3>统一认证，交易安全</h3>
                        <!-- <div class="content-subtitle">贷款一站式办理</div> -->
                        <p>基于统一的客户信息，通过人脸识别、银行U盾、短信验证码等认证手段确保互联网用户真实有效，避免交易安全问题。
                        </p>
                    </div>
                    <div class="imgright">
                        <img  src="../assets/Images/zhyy-img_01_03.png">
                    </div>
                </div>
                <div class="zh-linebox bg-gray">
                    <div class="imgleft">
                        <img src="../assets/Images/zhfw_02.png">
                    </div>
                    <div class="zh-content ">
                        <h3>统一管理，高效运维</h3>
                        <!-- <div class="content-subtitle">贷款一站式办理</div> -->
                        <p style="width:70%">
                            遵从住建部“综合服务平台建设导则”要求，建设综合服务管理系统，针对各服务渠道实现统一服务运行、统一渠道接入、统一信息发布及统一服务接入。
                        </p>
                    </div>
                </div>
                <div class="zh-linebox ">
                    <div class="zh-content content-left" style="padding-top:80px;">
                        <h3>数据多走路，群众不跑腿</h3>
                        <!-- <div class="content-subtitle">贷款一站式办理</div> -->
                        <p>
                            建立数据交换平台，通过与“智慧城市大数据中心”或政府相关部门数据共享实现跨部门业务协同办理，减少相关部门要件申请过程，保证业务受理信息真实。
                        </p>
                    </div>
                    <div class="imgright" style="float:right;padding-top:20px">
                        <img  src="../assets/Images/zhfw_05.png">
                    </div>
                </div>
                <div class="zh-linebox bg-gray">
                    <div class="imgleft">
                        <img src="../assets/Images/zhfw_06.png">
                    </div>
                    <div class="zh-content ">
                        <h3>以人为本，智能服务</h3>
                        <!-- <div class="content-subtitle">贷款一站式办理</div> -->
                        <p style="width:70%">
                            通过客户自然语言分析、语义情景分析及专业词汇识别，结合标准知识库为客户提供精准问答和咨询服务。
                        </p>
                        <a target="_blank" href="http://192.168.0.40:8080/"><span class="trybtn">点我试用</span></a>
                    </div>
                </div>

                <!--产品-->
                <div class="wp">
                    <div class="tit-i">
                        <h3>产品</h3>
                        <h5><span>PRODUCTS</span></h5>
                    </div>
                    <ul class="product">
                        <li>门户网站</li>
                        <li>网上营业大厅</li>
                        <li>官方微信</li>
                        <li>官方微博</li>
                        <li>手机客户端</li>
                        <li>服务热线</li>
                        <li>短信平台</li>
                        <li>多媒体查询机</li>
                        <li>自助一体机</li>
                        <li>X-ISP综合服务渠道接入平台</li>

                    </ul>
                </div>

            </div>
            <!--综合管理-->
            <div v-if="indexflag == 2 ">
                <img src="../assets/Images/zhgl_02.png">  
                <div class="tit-i">
                    <h3>综合管理</h3>
                    <h5><span>MANAGEMENT</span></h5>
                </div>
                <div class="zh-linebox wp" style="position:relative;">
                        <h3 style="position: absolute;left:50%;margin-left:-60px">无纸化低碳办公</h3>
                        <img src="../assets/Images/zhgl_05.png" style="width:100%;margin-top:30px">
                </div>
                <div class="zh-linebox bg-gray">
                    <div class="zh-content content-left" style="padding-top:80px;">
                        <h3>数字客观绩效</h3>
                        <!-- <div class="content-subtitle">贷款一站式办理</div> -->
                        <p>
                            通过数据仓库数据收集以及分析，利用绩效模型为管理层提供工作量绩效、计划目标绩效相关数据结果，保证绩效数据的客观、完整，为提升管理辅助决策。
                        </p>
                    </div>
                    <div class="imgright" style="float:right;padding-top:20px">
                        <img  src="../assets/Images/zhgl_08.png">
                    </div>
                </div>
                <div class="zh-linebox wp" style="text-align:center">
                        <h3 style="">移动化便捷办公</h3>
                        <img src="../assets/Images/zhgl_11.png" style="width:100%;">
                </div>
                <div class="zh-linebox bg-gray">
                    <div class="imgleft">
                        <img src="../assets/Images/zhgl_14.png">
                    </div>
                    <div class="zh-content ">
                        <h3>标准化知识积累</h3>
                        <!-- <div class="content-subtitle">贷款一站式办理</div> -->
                        <p style="width:70%">通过对中心政策、规程以及发文等标准知识库的积累，为客户提供智能咨询服务、为柜台人员提供标准解答服务以及为管理层提供考核依据。
                        </p>
                    </div>
                </div>
                 <!--产品-->
                <div class="wp">
                    <div class="tit-i">
                        <h3>产品</h3>
                        <h5><span>PRODUCTS</span></h5>
                    </div>
                    <ul class="product">
                        <li>OA办公自动化</li>
                        <li>绩效考核系统</li>
                        <li>固定资产管理</li>
                        <li>电子档案管理</li>
                        <li>经费合算系统</li>
                        <li>工资管理系统</li>
                        <li>售房款管理</li>

                    </ul>
                </div>


            </div>
            <div class="h50"></div>
        </div>
        <div class="c"></div>
        
    </div>
    <!-- end #bd -->
</div>
</template>
<style>
</style>
<script>
import { flexslider } from "../assets/Scripts/banner.js";
import { move, initState } from "../assets/Scripts/fn.js";
import { getNewsList, getBanner } from "../assets/Scripts/fn.js";
var self;
export default {
  data() {
    return {
      banners: [],
      content: "",
      teams: [],
      indexflag: 0
    };
  },
  mounted() {
        //this.changemenu(0);
        //setTimeout(() => {
            // console.log($.isEmptyObject(this.$route.params))
            if(!$.isEmptyObject(this.$route.params)){
                if(this.$route.params.id == 'hxyw'){this.changemenu(0);}
                if(this.$route.params.id == 'zhfw'){this.changemenu(1);}
                if(this.$route.params.id == 'zhgl'){this.changemenu(2);}
            }else{
                this.changemenu(0);
            }
        //}, 10);
  },
  methods: {
    changemenu(index) {
      this.indexflag = index;
      $(".yy-menuList")
        .eq(index)
        .find(".triangle")
        .fadeIn(10)
        .animate({
          top: -39
        });
      $(".yy-menuList")
        .eq(index)
        .find("img")
        .animate({
          top: -25
        });
      $(".yy-menuList")
        .eq(index)
        .find(".yy-menu")
        .animate({
          top: 100
        });
      $(".yy-menuList")
        .eq(index)
        .find("p")
        .fadeIn(10)
        .animate({
          top: 150
        });
      $(".yy-menuList")
        .eq(index)
        .css({
          "background-color": "#202d7a"
        });
      $(".yy-menuList")
        .eq(index)
        .siblings(".yy-menuList")
        .find(".triangle")
        .fadeOut(10)
        .animate({
          top: 0
        });
      $(".yy-menuList")
        .eq(index)
        .siblings(".yy-menuList")
        .find("img")
        .animate({
          top: 50
        });
      $(".yy-menuList")
        .eq(index)
        .siblings(".yy-menuList")
        .find(".yy-menu")
        .animate({
          top: 180
        });
      $(".yy-menuList")
        .eq(index)
        .siblings(".yy-menuList")
        .find("p")
        .fadeOut(10)
        .animate({
          top: 230
        });
      $(".yy-menuList")
        .eq(index)
        .siblings(".yy-menuList")
        .css({
          "background-color": "#131d59"
        });
      //$('.yy-menuList').click(function(){
      //点击切换
      // $(this).find('.triangle').fadeIn(10).animate({top:-39});
      // $(this).find('img').animate({top:-25});
      // $(this).find('.yy-menu').animate({top:100});
      // $(this).find('p').fadeIn(10).animate({top:150});
      // $(this).css({'background-color':"#202d7a"})
      // $(this).siblings('.yy-menuList').find('.triangle').fadeOut(10).animate({top:0});
      // $(this).siblings('.yy-menuList').find('img').animate({top:50});
      // $(this).siblings('.yy-menuList').find('.yy-menu').animate({top:180});
      // $(this).siblings('.yy-menuList').find('p').fadeOut(10).animate({top:230});
      // $(this).siblings('.yy-menuList').css({'background-color':"#131d59"});
      //})
    },
    tryClick(){
        // var webset_pop = $(this).parents('li').find('.webset-pop');
        $(".webset-pop").css({zIndex: 10}).animate({
            opacity: 1,
            left: 0
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/zhyy.vue